import { IOpeningProcedure } from "models/OpeningProcedureModel";
import { BaseService } from "./base.service";

class OpeningProcedureServiceInternal extends BaseService {
	getOpeningProcedureList = async (): Promise<IOpeningProcedure[]> =>
		this.callApi<IOpeningProcedure[]>(
			`OpeningProcedure/GetAll`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const OpeningProcedureService = new OpeningProcedureServiceInternal();
